import React from "react";
import "./GameItemSk.css";
export const GameItemSk = () => {
  console.log("item");
  return (
    <div className="gameSk">
      <div className="gameSkImg"></div>
      <div className="gameSkIo">
        <div className="gameSkText sm"></div>
        <div className="gameSkText hg"></div>
      </div>
    </div>
  );
};
